export default __webpack_public_path__ + "static/media/sneakers1024.3d0b19f4.png";